<template>
  <div class="base_detail_modal">
     
    <Modal    
          v-model="add_repair_modal"
          title="上门维修" 
            :width="screenWidth*0.7"
          @on-cancel="cancel" @on-visible-change="handleVisibleChange">
          <div class="base-modal" v-if="add_repair_modal"> 
            <VuePerfectScrollbar :style="{ 'display': 'block','height':screenHeight*0.6+'px' ,'overflow':'auto'}">
              <Alert type="warning" show-icon closable>温馨提示:未提交前请勿刷新页面，否则会丢失填入的数据和附件。</Alert>   
            <Form :model="dataDetail" ref="dataDetailForm" :label-width="150" :rules="ruleValidate">
               
              <Alert>基本信息</Alert>   
              <Row>
                
                <Col span="12">
                  <!-- <FormItem label="房屋地址"  prop="房屋地址">
                    <Input v-model="dataDetail['房屋地址']" placeholder="暂无" :disabled="false" clearable></Input>
                  </FormItem>    -->
                    <FormItem label="房屋地址"  prop="房屋地址">
                     <Select filterable :remote-method="findHouse" :loading="houseSelectloading"  v-model="selectedHouseId" @on-select="chooseHouse" placeholder="请选择..." clearable>
                        <Option   v-for="item in selectHouseList" :key="item['房源ID']" :value="item['房屋地址']">{{item['房屋地址']}}</Option> 
                      </Select>
                  </FormItem>
                </Col> 
               <Col span="12">
                <FormItem label="*房屋地址支持搜索"></FormItem>
                </Col>
              </Row>
          
              <Row>
                <Col span="12">
                  <FormItem label="租客姓名"   prop="租客姓名">
                    <Input v-model="dataDetail['租客姓名']" placeholder="暂无" :disabled="false"></Input>
                  </FormItem>
                </Col> 
                <Col span="12">
                  <FormItem label="报修人联系电话"  prop="联系电话">
                    <Input v-model="dataDetail['联系电话']" placeholder="暂无" :disabled="false"></Input>
                  </FormItem>
                </Col> 
               
              </Row> 
           
            <Alert>维修清单(共{{questionList.length}}条)</Alert>   
            <div v-for="(item,index) in questionList" :key="item['问题描述']" style="margin-top: 20px;">

               <Alert type="success" v-if="index==0">维修项（{{index+1}}/{{questionList.length}}） </Alert>  
              <div class="small-title" v-else>
                <Alert type="success">维修项（{{index+1}}/{{questionList.length}}） </Alert>  
                 <Button type="error" ghost @click="deleteQuestion(index)" >删除</Button>     
              </div>
          
           
              <Row>
                <Col span="24">
                  <FormItem label="故障描述"   prop="故障描述">
                    <Input v-model="item.gzms" placeholder="暂无" :disabled="false"></Input> 
                  </FormItem>
                </Col>  
              </Row>
            <Row>
                <Col span="12">
                  <FormItem label="维修员"  prop="维修员">
                    <Input v-model="item.repairPerson" placeholder="暂无" :disabled="false" clearable></Input>
                  </FormItem>
                </Col> 
                  <Col span="12">
                  <FormItem label="维修员联系电话"  prop="维修员联系电话">
                    <Input v-model="item.repairPersonTel" placeholder="暂无" :disabled="false" clearable></Input>
                  </FormItem>
                </Col> 
               </Row>

               <!-- 附件 -->
                  <Upload :action="uploadUrl"  
                    :headers="{ 'Authorization': 'Bearer ' +token }"
                    accept=".jpg,.jpeg,.png,.pdf"
                    :on-success="(response, file, fileList) => uploadSuccess_wechat(response, file, fileList, null,null,index)" 
                    :show-upload-list="true" 
                    max-size="100*1024" >
                    <Button type="info" style="margin-left:20px;">新增附件</Button>
                  </Upload>

                  <Table border :columns="fjColums" :data="item.fj" :max-height="400"> 
                  <template #img="{ row, imageIndex } " >
                      <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png','webg'].includes(row.suffix)">
                        
                        <img style="width:200px;height:200px;" :src="row.img" alt="">
                      </div>
                      <div v-else>仅支持图片预览</div>
                    </template> 
                    <template #action="{ row, imageIndex } " >
                      <div class="buttomGroup">
                        <div class="btn ck" @click="watchFile(row,'shfjList')">查看</div>
                        <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'shfjList')">下载</div> 
                        <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(index,imageIndex)">删除</div>
                      </div>
                    </template> 
                  </Table>
               </div>


          


              </Form>
          </VuePerfectScrollbar>

          
          </div>
          <template #footer>
                 <div style="display: flex;justify-content: flex-end;gap:20px;">
                 <Button type="success" @click="  addNewQuestion()">添加新维修子项</Button>
                 <Button type="default" @click="cancelModal">取消</Button>
                <Button type="primary" @click="handleSubmit('dataDetailForm')">提交</Button>
                </div>
            </template>

    </Modal>

  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'; 
import {utilTools} from "@/utils/js/utilTools.js"
import {zfglMethod_2_001} from "@/api/2租房管理/2_001_cxfy.js"; 
import {smwxMethod_9_001} from "@/api/9小程序管理/9_001_smwx"; 
import {cbglMethod} from "@/api/8成本管理/cbgl";
import {userMethod} from "@/api/login/user.js"
export default {
  name:"add_repair_modal",
  comments:{VuePerfectScrollbar},
  props:{
    dataDetail:{
      type:Object,
      default:{
        "房屋地址":"",//房屋地址
                "房源ID":"",//房源ID 
                "故障类型":"",//故障类型
                "故障区域":"",//故障区域
                "上门日期":"",//上门日期
                "上门时间":"",//上门时间
                "故障描述":"",//故障描述
                "联系电话":"",//联系电话
                "附件信息":[],//附件信息 
                "租客姓名":"",//联系电话
                "联系电话":"",//联系电话
      },
    },
    lldTableData:{
      type:Array,
      default:{},
    },
    gsdTableData:{
      type:Array,
      default:{},
    }
  },
    data() {
        return { 
          imgBaseUrl:"https://mp.xiaojiabiyu.net.cn/cms/v1/files/transform?uri=",
          //上传文件s
          uploadUrl:"/xjby/api/file/uploadHouseFiles",
          fjColums:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '文件名', key: 'show_name', align: 'center'}, 
            {title: '预览', slot: 'img', align: 'center'},
            {title: '操作', slot: 'action', width:300, align: 'center'}
          ],
          
          add_repair_modal:false,//控制弹窗开关 
          keyNotShow:["id","clsId","dataFieldMap","ciSource","tVersion","ciStatus","viewId","tenant"],
          skjeValidate :(rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入收款金额'));
                }
                if (value <= 0 ) {
                            callback(new Error('请核实您输入的金额'));
                        } 
              
              },
          ruleValidate:{
            skje: [
                        {  validator: this.skjeValidate,   trigger: 'blur' }
                    ],
                     
                  // qqh: [
                  //       { required: true, message: '丘权号不能为空', trigger: 'blur' }
                  // ],
                  },
          dataDetailShow:{},
          xzqList:[
            {label:"白下区",value:""}, {label:"鼓楼区",value:""}, {label:"建邺区",value:""},
            {label:"江宁区",value:""}, {label:"老下关",value:""}, {label:"浦口区",value:""},
            {label:"栖霞区",value:""}, {label:"秦淮区",value:""}, {label:"宣武区",value:""},
            {label:"雨花台区",value:""}, 
          ],
          // 筛选房源的select相关参数
          selectHouseList:[],//房屋地址筛选
          houseSelectloading:false,//房屋地址筛选-select加载
           selectedHouseId: null, // 用来存当前用户选中的房源ID
          repairEmployeeList:[],//维修工信息,CONCAT('(', "工种", ')', username) AS formatted_username,username,accountno,"工种"
        
          ryList:[],//根据工时单-工种更新人员名单
          // 损坏附件情况
          shfjList:[],
          // 领料单相关
          lldSpflList:[],//领料单商品分类
          lldSpmcList:[],//领料单商品名称
          lld:{
            spfl:"",spmc:"",spsl:0, 
          },
          // lldTableData:[],
          lldTableColumns:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '商品分类', key: 'productCategory', align: 'center'}, 
            {title: '商品代码', key: 'productCode', align: 'center'}, 
            {title: '商品名称', key: 'productName', align: 'center'}, 
            {title: '商品数量', key: 'productQuantity', align: 'center'}, 
            {title: '计量单位', key: 'unit', align: 'center'}, 
            {title: '规格型号', key: 'specification', align: 'center'}, 
            {title: '领料仓库', key: 'warehouse', align: 'center'}, 
            {title: '操作', slot: 'action', width:140, align: 'center'}
          ],
          // 工时单相关
          gsd:{
            gzlx:"装修工时",gz:"",rymc:"",gs:0
          },
          gsdTableColumns:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '房屋地址', key: 'fwdz', align: 'center'}, 
            {title: '工作类型', key: 'gzlx', align: 'center'}, 
            {title: '工种', key: 'gz', align: 'center'}, 
            {title: '人员名称', key: 'rymc', align: 'center'}, 
            {title: '工时', key: 'gs', align: 'center'},  
            {title: '操作', slot: 'action', width:140, align: 'center'}
          ],
          ruleValidate:{
                  "房屋地址": [
                        { required: true, message: '房屋地址不能为空', trigger: 'blur' }
                    ],
                  //   "故障类型": [
                  //       { required: true, message: '故障类型不能为空', trigger: 'blur' }
                  // ],
                  // "故障区域": [
                  //       { required: true, message: '故障区域不能为空', trigger: 'blur' }
                  // ],
                  // "租客姓名": [
                  //       { required: true, message: '租客姓名不能为空', trigger: 'blur' }
                  // ],
                  // "联系电话": [
                  //       { required: true, message: '租客手机号码不能为空', trigger: 'blur' }
                  // ],
                  },
          questionList:[//问题列表
                   {
                    id:"",
                    gzms:"",//问题描述（必填）
                    repairPerson:"",//维修人
                    repairPersonTel:"",//维修人联系方式
                    fj:[],//问题图片列表 
                  }
          ],
          // gsdTableData:[],
           
        }

    },
    computed: {
      
        screenWidth() {
            return this.$screenWidth;
        },
        screenHeight() {
            return this.$screenHeight;
        },
    },
    mounted(){
      
    },
    created(){  
      console.log("dataDetail===",this.dataDetail)

console.log("u",this.$store.state.userInfo);
    },
   
    watch:{
      dataDetail:{
        deep:true,
        haldler(old,newval){
          console.log("old==",old)
          console.log("newval==",newval)
        }
      }
    },
    methods:{
      changeSmrq(date){
        console.log("1112223233")
        console.log("date==",date)
        this.dataDetail['上门日期']=date
        console.log("this.dataDetail==",this.dataDetail)
      },
      // 弹窗显示/隐藏事件
      handleVisibleChange(visible){
        // console.log("visible==",visible)
        // if(visible){
        //   this.initRepairEmployee()
        //   this.initlldSpflList() 
        //   this.cleanPhotoList()
        // }
        // this.cleanPhotoListV3("损坏附件","1_上门维修",this.dataDetail.id,"损坏附件",null,null)
       
      },
              // 删除单个问题（>=2时）
        deleteQuestion(index){  
          console.log("delete按钮")
        let questionList=this.questionList
        let item = questionList[index]
        if(questionList.length<=1){
            this.$Message.warning({
              content:"至少要保留一个问题",
              duration:1,
            });
        
          return;
        } 
          let _this=this
           this.$Modal.confirm({
              title: '确认删除提醒',
              content: `<br>是否删除删除当前问题[${index+1}]？删除后不可恢复。<br>`,
              onOk(){
                 questionList = questionList.filter((_, i) => i !== index)
                  _this.questionList=questionList

              }})
    
      },
      // 新版清洗照片（新旧系统一起获取）（非房源版本）
      cleanPhotoListV3(key,father_table,father_id,type_1,type_2,old_data){
        let data= []
        //  新系统
        fileMethod.selectFiles({father_table:father_table,father_id:father_id,type_1:type_1,type_2:type_2}).then((res)=>{
          console.log(key,"--查询结果--",res)
         if(res.data.selectRes){
          res.data.selectRes.forEach((i)=>{
              let new_obj={
                    show_name:i.show_name,
                    type_2:i.type_2,
                    img: window.applicationConfig.fileBaseUrl + i.show_path,
                    suffix:i.suffix, 
                    source:"new_system",
                    id:i.id
                  }
                  data.push(new_obj);
            })
         } 
         console.log("查询后组装--",data)
         this.saveImage(key,data)
        })
      
      
         
      },
      // 加载员工（维修工）
      initRepairEmployee(){
          userMethod.getRepairUser().then((res)=>{
            this.repairEmployeeList=res.data
             
          })
      },
      // 点击维修人
      selectWxr(val){
        console.log("val==",val)
        this.dataDetail.wxrlxdh=this.repairEmployeeList.find((item)=>{return item.username==val}).mobile
      },
      // 提交
      handleSubmit(name) {
       this.$refs[name].validate((valid) => {
         if (valid) {
            // this.$Message.success('Success!'); 
            let _this=this
            this.$Modal.confirm({
              title: '确认提交提醒',
              content: `<br>请核实您输入的信息<br>`,
              onOk(){
                  let param_1={
                    version:"2",//版本
                    fydz:_this.dataDetail['房屋地址'],//房屋地址
                    fyid:_this.dataDetail['房源ID'],//房源ID   
                    bxr:_this.$store.state.userInfo.name,
                    zkxm:_this.dataDetail['租客姓名'],
                    lxdh:_this.dataDetail['联系电话'],
                    bz:"简易版-工作人员上传",
                    hasChildren:true
                  }
                  smwxMethod_9_001.insertRepairRecord(param_1).then((res)=>{
                     if(res.success){
                      let newId = res.data.newId
                      _this.questionList.forEach((i)=>{
                        i.father_id = newId,
                        i.question_discribe=i.gzms,
                        i.repair_worker=i.repairPerson,
                        i.rapair_worker_tel=i.repairPersonTel,
                        i.house_add=param_1.fydz,
                        i.hire_name=param_1.zkxm,
                        i.hire_tel=param_1.lxdh,
                        i.state="待维修",
                        i.house_id=param_1.fyid
                      })

                       smwxMethod_9_001.insertDetailRecord(_this.questionList).then((res_2)=>{
                          console.log("res_2===",res_2)
                        if(res.code==200){
                            _this.$Message.success('添加成功！');
                            _this.add_repair_modal=false
                          _this.$emit("init")
                        }

                          })
                    
                    }else{
                         this.$Message.error('添加失败！请联系管理人员！');
                    }

                  })

              
              
              
              
              
              
              // 旧版
                // let param=_this.dataDetail 
                // // param['附件信息']=param['附件信息'].filter(item => item.needInsert == true);
                // console.log("预提交===》",param)
                // smwxMethod_9_001.insertRepairInfoFromWeb(param).then((res)=>{
                //   console.log("新增上门维修——res====",res)
                //   if(res.data.insertNum!=null){
                //     _this.$Message.success("记录成功！")
                //     _this.$emit("init")
                //     console.log("11233")
                //     _this.add_repair_modal=false 
                //   }
                // })  
              } 
            })
         } else {
             this.$Message.error('请核实输入的内容!');
         }
        })
      },
      // select用于查询房源
      findHouse(query){
       
        if (query !== '') {
                    this.houseSelectloading = true;
                    setTimeout(() => {
                        this.houseSelectloading = false;
                         let params={
                          houseName:query 
                         }
                         smwxMethod_9_001.getHouseListByName(params).then((res)=>{
                          console.log("res==",res)
                          this.selectHouseList=res.data.list
                         })
                          
                    }, 200);
                } else {
                    this.selectHouseList = [];
                }
      },
      // select用于选择item时传输房源id
    // 选中某个房屋地址后触发
    chooseHouse(selectedHouseId) {
      console.log("选中的房源地址是：", selectedHouseId);
      console.log("this.selectHouseList==",this.selectHouseList)
        // 找到对应的 item 对象
        const selectedItem = this.selectHouseList.find(
          (item) => item["房屋地址"] === selectedHouseId
        );

        if (selectedItem) {
          console.log("选中的完整对象是：", selectedItem);

        
          this.dataDetail['房源ID']=selectedItem['房源ID']
           this.dataDetail['房屋地址']=selectedItem['房屋地址']
          console.log("dataDetail==",this.dataDetail)
          // 或者：如果你能直接修改 props（不推荐），但通常你应该用 emit 通知父组件更新
          // 注意：props 是只读的，你应该通过 emit 通知父组件去改
        } else {
          console.warn("未找到选中的房源对象，ID=", selectedHouseId);
        }
      },
      // 旧系统照片下载并暂存到新系统中
      downloadAndSaveImage(){
        
      },
        // 添加新问题
      addNewQuestion(){ 
        let questionList=this.questionList
        console.log("questionList===",questionList)
        let msg=""
        if(questionList.length>=10){
          msg="一个房源一次最多添加10条问题！"
        }else{
          let newQuestion= {
            id:"",
            gzms:"",//问题描述（必填）
            repairPerson:"",//维修人 
            repairPersonTel:"",//维修人联系方式 

            fj:[],//问题图片列表
          }
          questionList.push(newQuestion)
          this.questionList=questionList
          msg="添加成功！"
        }
        this.$Message.info({
          content:msg,
          duration:1,
        });
      
        
      },
      // 存放照片
      saveImage(key,data){
          
          if(key==="客厅照片"){ this.ktImgList=data }
          else if(key==="卧室照片"){ this.wsImgList=data }
          else if(key==="厨房照片"){ this.cfImgList=data }
          else if(key==="卫生间照片"){ this.wsjImgList=data }
          else if(key==="其他照片"){ this.qtImgList=data }

          else if(key==="房屋托管合同信息"){ this.fwtghtImgList=data }
          else if(key==="产证信息"){ this.czImgList=data }
          else if(key==="身份证信息"){ this.sfzImgList=data }
          else if(key==="授权委托书"){ this.sqhtsImgList=data } 
          else if(key==="损坏情况"){ this.shfjList=data } 
          else if(key==="损坏附件"){ this.dataDetail['附件信息']=data } 
          

        },
      // 房屋文件上传
      async uploadSuccess_dataDetail(response, file, fileList, name,imageType) {
        console.log("1上传成功fileList===", fileList);
        console.log("response===", response);
        console.log("file===", file);
        console.log("name===", name);

       

         
          // let img_base64 = await utilTools.fetchImageAsBase64("/xjby/view/" + obj.show_url, localStorage.getItem('token'));
          // obj.img_base64 = img_base64;
           let obj = {
            save_name: response.data.saveName,
          save_url: response.data.savePath,
          show_name: response.data.showName,
          show_url: response.data.showPath,
          suffix: response.data.suffix,
          img: window.applicationConfig.fileBaseUrl +response.data.showPath,
          type_1:"租客上传",
          type_2:imageType?imageType:null,
          bz:"new_system", 
          needInsert:true
        };
          console.log("dataDetail==", this.dataDetail);
       
          this.dataDetail['附件信息'].push(obj);
          console.log("this.dataDetail['附件信息']==",this.dataDetail['附件信息'])

       
      },
         // 房屋文件上传
      async uploadSuccess_wechat(response, file, fileList, name,imageType,itemIndex) {
        console.log("1上传成功fileList===", fileList);
        console.log("response===", response);
        console.log("file===", file);
        console.log("name===", name); 
        console.log("itemIndex===", itemIndex);
       

         
          // let img_base64 = await utilTools.fetchImageAsBase64("/xjby/view/" + obj.show_url, localStorage.getItem('token'));
          // obj.img_base64 = img_base64;
           let obj = {
            save_name: response.data.saveName,
          save_url: response.data.savePath,
          show_name: response.data.showName,
          show_url: response.data.showPath,
          suffix: response.data.suffix,
          img: window.applicationConfig.fileBaseUrl +response.data.showPath,
          type_1:"上门维修_子项目_问题图片",
          type_2:imageType?imageType:null,
          bz:"new_system", 
          needInsert:true
        };
       
       
          this.questionList[itemIndex].fj.push(obj);
            console.log("this.questionList[itemIndex]==", this.questionList[itemIndex]);

       
      },
      cleanData(obj, properties) { 
        console.log("obj===",obj)
        properties.forEach(property => {
          delete obj[property];
        }); 
        return obj;
      },
       // 在线预览文件
       watchFile(row,name) { 
        utilTools.downloadFromUrl("/xjby/view/" + row.show_url, row.show_name, "open",localStorage.getItem('token'))
      },
      // 下载附件
        downloadFile(row,name) {
          utilTools.downloadFromUrl("/xjby/view/" + row.show_url, row.show_name, "download",localStorage.getItem('token'))
      },
      // 删除预上传的附件 
      deleteFileBefore(index,imageIndex) {
        let _this=this
        this.$Modal.confirm({
        title: '确认删除提醒',
        content: `<br> 删除后不可恢复<br>`,
        onOk(){
          _this.questionList[index].fj.splice(imageIndex, 1);

        }
      })
      },
    
      // 前台新增领料单
      addLld(){
        if(this.lld.spsl<=0){
          this.$Message.error("商品数量不可小于0")
          return ;
        }
        else{
          let item = this.lldSpmcList.find((i)=>{return i['商品名称']===this.lld.spmc}) 
        let obj = {
          productCategory:item['商品分类'],
          productCode:item['商品代码'],
          productName:item['商品名称'],
          productQuantity:this.lld.spsl,
          unit:item['计量单位'],
          specification:item['规格型号'],
          warehouse:"门店",
          needInsert:true
        }
        this.lldTableData.push(obj)
        }
     
      },
       // 前台新增工时单
       addGsd(){
        if(this.gsd.gz==""||this.gsd.gz==null){
          this.$Message.error("工种不可为空")
          return ;
        }
        else  if(this.gsd.rymc==""||this.gsd.rymc==null){
          this.$Message.error("人员名称不可为空")
          return ;
        }
        else  if(this.gsd.gs<=0){
          this.$Message.error("工时填写错误")
          return ;
        }
        else{
         
        let obj = this.gsd
        console.log("dataDetail",this.dataDetail) 
        Object.assign(obj, { "fwdz": this.dataDetail['房屋地址'] });
        Object.assign(obj, { "needInsert": true}); 
        this.gsdTableData.push(obj)
        }
     
      },
      // 前台删除 
      deleteLRecord(index){
        this.dataDetail['附件信息'].splice(index, 1);
      },
       // 前台删除工时单
       deleteGsd(index){
        this.gsdTableData.splice(index, 1);
      },
      // 损坏附件上传
        async uploadSuccess_house(response, file, fileList, name,imageType) {
        console.log("1上传成功fileList===", fileList);
        console.log("response===", response);
        console.log("file===", file);
        console.log("name===", name);

        let obj = {
          save_name: response.data.saveName,
          save_url: response.data.savePath,
          show_name: response.data.showName,
          show_url: response.data.showPath,
          suffix: response.data.suffix,
          type_1:"租客上传",
          type_2:imageType?imageType:null,
          bz:"new_system",  
        };

        try {
          let img_base64 = await utilTools.fetchImageAsBase64("/xjby/view/" + obj.show_url, localStorage.getItem('token'));
          obj.img_base64 = img_base64;
          console.log("obj==", obj);
          this.dataDetail['附件信息'].push(obj)

          // if (name === "czImgList") {
          //   this.czImgList.push(obj);
          // }
          // else if(name === "sfzImgList") {
          //   this.sfzImgList.push(obj);
          // }
          // else if(name === "fwtghtImgList") {
          //   this.fwtghtImgList.push(obj);
          // }
          // else if(name === "fwImgList") {
          //   this.fwImgList.push(obj);
          // }
          // else if(name === "sqhtsImgList") {
          //   this.sqhtsImgList.push(obj);
          // }
        } catch (error) {
          console.error("Error fetching image as Base64:", error);
          // 处理错误，例如通知用户或设置默认值
        }
      },
        // 清洗照片
        cleanPhotoList(key){ 
          if(this.dataDetail.source==="new_system"){
            let data = this.dataDetail[key];
            zfglMethod_2_001.getHousePhotosById({id:this.dataDetail.id,type_1:key,}).then((res)=>{
              console.log(key,"--查询结果--",res)
              let data = res.data
              this.getPhotoList_newSystem(key,data)
            }) 
          }else{
            if (!this.dataDetail[key]) {
              this.saveImage(key,[])
            }
            
            let data = JSON.parse(this.dataDetail[key]);
            if (data.length === 0) {
              this.saveImage(key,[])
            }
            return  this.getPhotoList_oldSystem(key,data)
          } 
         },
         //旧系统获取图片
        getPhotoList_oldSystem(key,data){
          let imgList = [];
          
          for (const obj of data) {
            if (obj.bz === "new_system") {
              let tempObj={
                    show_name:obj.show_name,
                    type_2:obj.type_2,
                    img:"http://localhost:8080/xjby/view/" + obj.show_path,
                    
                  }
                  imgList.push(tempObj);
              
              // imgList.push("http://localhost:8080/xjby/view/"+obj.show_url);
            } else {
              let tempObj={
                    show_name:obj.show_name,
                    type_2:obj.type_2,
                    img:"http://localhost:8080/xjby/view/" + obj.fileAddress
                  }
                  imgList.push(tempObj);
              // imgList.push(this.imgBaseUrl + obj.fileAddress);
            }
          }
          console.log("imgList==",imgList) 
          this.saveImage(key,imgList)
        },
//新系统获取图片
        getPhotoList_newSystem(key,data){
          let imgList = [];
          zfglMethod_2_001.getHousePhotosById({id:this.dataDetail.id,type_1:key}).then((res)=>{
           if(res.data!=null&&res.data.list.length>0){
            res.data.list.forEach((i)=>{
              let obj={
                    show_name:i.show_name,
                    type_2:i.type_2,
                    img:"http://localhost:8080/xjby/view/" + i.show_path,
                    suffix:i.suffix, 
                    id:i.id
                  }
                  imgList.push(obj);
              // imgList.push("http://localhost:8080/xjby/view/"+i.show_path);
            })
           }
           this.saveImage(key,imgList)
          })
          
        }, 
          // 存放照片
      saveImage(key,data){
       this.shfjList=data
      },
      
      changeGz(name){
        console.log("repairEmployeeList==",this.repairEmployeeList)
        this.ryList= this.repairEmployeeList.filter(employee => employee['工种'] === name);
      },
   
      cancel(){
        this.modal=false
      },
     
      changeHtdqr(date){
        this.dataDetail.htdqr=date
      },
      changeJfrq(date){
        this.dataDetail.jfrq=date
      },
      // 关闭弹窗
      cancelModal(){
        let   questionList=[//问题列表
                   {
                    id:"",
                    gzms:"",//问题描述（必填）
                    repairPerson:"",//维修人
                    repairPersonTel:"",//维修人联系方式
                    fj:[],//问题图片列表 
                  }
          ]
          let dataDetail={
             "房屋地址":"",//房屋地址
                "房源ID":"",//房源ID 
                "故障类型":"",//故障类型
                "故障区域":"",//故障区域
                "上门日期":"",//上门日期
                "上门时间":"",//上门时间
                "故障描述":"",//故障描述
                "联系电话":"",//联系电话
                "附件信息":[],//附件信息 
                "租客姓名":"",//联系电话
                "联系电话":"",//联系电话
          }
          this.questionList=questionList
          this.dataDetail=dataDetail
          this.add_repair_modal=false

      }
     
    }


}
</script>

  
  <style lang="scss" >
 

.base-modal{
        width: 100%;
        height: 660px;
        padding: 20px;
        .base-modal-line{
            width: 100%;
            height: auto;
            display: flex;
            gap:2%;
            align-items: center;
            justify-content: center;
            
            .item_1{
                width: 48%;
                height: auto;
                display: flex; 
                font-size: 24px;  
                text-align: center;
                 line-height: 50px;
                 border-bottom: 1px solid #c3c3c3;
                 border-right: 1px solid #c3c3c3;
                 border-left: 1px solid #c3c3c3;
                .item_1-title{
                    width: 35%; 
                    height: auto;
                    color:#333333;
                    background-color: #cccccc;
                    
                }
                .item_1-value{
                    width: 65%;
                    color:#555555;
                    word-wrap: break-word; /* 允许长单词换行 */
                    word-break: break-all; /* 允许在任意字符处换行 */
                    overflow-wrap: break-word; /* 处理长单词换行 */
                }
               
                
            }
            .item_2{
                width: 100%;
                height: auto;
                .item_2-title{
                    width: 100%;
                    color:#333333;
                }
            }

        }
        .small-title{width: 100%;

          display: grid;
          grid-template-columns: 92% 5%;
          column-gap: 3%;
        }
        .buttomGroup{
                display: flex;
                width: 100%;
                text-align: center;
                align-items: center;
                justify-content: center;
                gap:20px;
                .btn{
                  width: 56px;
                  height: 34px;
                  border-radius: 4px;
                  font-size: 16px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  line-height: 34px;
                  text-align: center;
                  cursor: pointer;
                }
                .ck{
                  background:rgba($color: #307EFF, $alpha: 0.1);
                  color: #307EFF;
                }
                .tg{
                  background:rgba($color: #0FD738, $alpha: 0.1);
                  color: #01B054 ;
                }
                .th{
                  background:rgba($color: #FF890A, $alpha: 0.1);
                  color: #FF890A;
                }
                .bj{
                  background:rgba($color: #307EFF, $alpha: 0.1);
                  color: #307EFF;
                }
                .tj{
                  background:rgba($color: #1CB9FF, $alpha: 0.1);
                  color: #0A9EE0;
                }
                .sc{
                  background:rgba($color: #EA1611, $alpha: 0.1);
                  color: #EA1611;
                }
              }
              .item {
                  display: flex;
                  align-items: center;
                    width: 33%;
                  .label {
                    text-align: center;
                    width: 30%;
                    font-size: 16px;
            
                    font-weight: 400;
                    color: #333333;
                  }
            
                  .value {
                    width: 70%;
                    display: flex;
                    gap:20px;
                  }
                 
                }
    }
  </style>